import CreateEditCreditorForm from './CreateEditCreditorForm';

export default CreateEditCreditorForm;
